import type { SpinnerProps } from '@bos/ui';
import { Spinner } from '@bos/ui';

import type { ReplaceTestIdWithAppOne } from '../const/testIds';

export type AppSpinnerProps = ReplaceTestIdWithAppOne<SpinnerProps>;

export const AppSpinner = (props: AppSpinnerProps) => <Spinner {...props} />;
